import { EditModeInfoExpense } from "../../rtb/info/class/editMode-Info-expense";
import { FlightDate } from "./flight-date";
import { TableData } from "app/components/class/table-data";
import { FlightDateSave } from "./flight-date-save";
import {  responsecreateProduct } from "../http/res/response-create-product";
import { Folder } from "./folder";

export class Expense {
    id: number;
    dealerShipId: number;
    month: number;
    year: number;
    productId: string;
    productCategoryId: string;
    targetBudget: number;
    actualBudget: number;
    flightDate: Array<FlightDate> = [];
    flightDateSave: Array<FlightDateSave> = [];
    campaign: string;
    strategy: string;
    description: string;
    notes: string;
    coop: number;
    creativeId: string;
    coopPercent: number;
    targetBudgetPercent: number;
    budget: number;
    actualBudgetPercent: number;
    folders: Array<Folder>;
    isMedia: number;
    constructor() { }
    public onInitDefault(productId: string, productCategoryId: string) {
        this.targetBudget = 0;
        this.actualBudget = 0;
        this.actualBudgetPercent = 0;
        this.campaign = "";
        this.strategy = "";
        this.description = "";
        this.productId = productId;
        this.productCategoryId = productCategoryId;
        this.notes = "";
        this.coop = 0;
        this.creativeId = "";
        this.budget = 0;
        this.targetBudgetPercent = 0;
        this.coopPercent = 0;
        this.id = 0;

    }
    public onInit(data) {
        this.actualBudget = data.actualBudget
        this.campaign = data.campaign;
        this.coop = data.coop;
        this.creativeId = data.creativeId;
        this.description = data.description;
        this.folders = data.folders;
        this.flightDate = data.flightDate.map(item => new FlightDate(item));
        this.id = data.id;
        this.isMedia = data.isMedia;
        this.notes = data.notes;
        this.productCategoryId = data.productCategoryId;
        this.productId = data.productId;
        this.strategy = data.strategy;
        this.targetBudget = data.targetBudget;
    }
    public onInitAddInfoExpense(data: Expense,flightDate, editMode: EditModeInfoExpense) {
    this.dealerShipId =  editMode.settings.dealerShipId;
          this.month = editMode.settings.month;
          this.year = editMode.settings.year;
          this.productId = (editMode.Command === "add-product") ? editMode.product.id.split('products-').join('') : editMode.product.productId;
          this.productCategoryId = (editMode.Command === "add-product") ? editMode.categori.id.split('categories-').join('') : editMode.categori.productCategoryId;
          this.targetBudget = data.targetBudget;
          this.actualBudget = data.actualBudget;
          this.flightDate = flightDate;
          this.campaign = data.campaign;
          this.strategy = data.strategy;
          this.description = data.description;
          this.notes = data.notes;
          this.coop = data.coop;
          this.creativeId = data.creativeId;
      
    }
    public onInitAdd(data, tableData: TableData) {
        this.dealerShipId = tableData.settings.dealerShipId;
        this.month = tableData.settings.month;
        this.year = tableData.settings.year;
        this.productId = data.productId;
        this.productCategoryId = data.productCategoryId;
        this.targetBudget = data.targetBudget;
        this.actualBudget = data.actualBudget;
        this.flightDate = data.flightDate;
        this.campaign = data.campaign;
        this.strategy = data.strategy;
        this.description = data.description;
        this.notes = data.notes;
        this.coop = data.coop;
        this.creativeId = data.creativeId;

    }
    public onInitSave(data, flightDate) {
        this.id = data.id;
        this.targetBudget = data.targetBudget;
        this.actualBudget = data.actualBudget;
        this.flightDate = flightDate;
        this.campaign = data.campaign;
        this.strategy = data.strategy;
        this.description = data.description;
        this.notes = data.notes;
        this.coop = data.coop;
        this.creativeId = data.creativeId;
    }

    public onInitAfterCreateProduct(editMode: EditModeInfoExpense, data:Expense, res:responsecreateProduct, flightDate) {
        this.dealerShipId = editMode.settings.dealerShipId;
        this.month = editMode.settings.month;
        this.year = editMode.settings.year;
        this.productId = String(res.productId);
        this.productCategoryId = editMode.categori.productCategoryId;
        this.targetBudget = data.targetBudget;
        this.actualBudget = data.actualBudget;
        this.flightDate = flightDate;
        this.campaign = data.campaign;
        this.strategy = data.strategy;
        this.description = data.description;
        this.notes = data.notes;
        this.coop = data.coop;
        this.creativeId = data.creativeId;

    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/expense/expense.ts